import { GeoCodeRenderer, ExpandCellRenderer } from '@dataGrid/components/cellRenderer/index';
import RecommendationRenderer from '../Grid/cellRenderer/RecommendationRenderer';
import { DRIVER_RECOMMENDATION_COL_ID } from '../Grid/headerRenderer/constants';
import { StyledGroupCellRenderer } from './styles';
import PickupNumberRenderer from '../Grid/cellRenderer/PickupNumberCellRenderer';
import { isSingleInGroupPickups, isGroupHeaders } from './utils';

const getPickupTypeString = (allPickupTypes, pickupType) => {
  if (allPickupTypes?.length) {
    return allPickupTypes.join(', ');
  }
  return pickupType?.length ? pickupType.join(', ') : '';
};

const GroupCellRenderer = (props) => {
  const { classes, data, colDef, context, value } = props;
  const colId = colDef?.colId;
  const field = colDef?.field || colId;

  if (!isGroupHeaders(data)) {
    if (colId === DRIVER_RECOMMENDATION_COL_ID && isSingleInGroupPickups(data)) {
      return <RecommendationRenderer {...props} />;
    }
    if (colId === 'isGeoCoded' && isSingleInGroupPickups(data)) {
      return <GeoCodeRenderer {...props} value={data.isGeoCoded} />;
    }
    return value || '';
  }

  if (!context) {
    return value || '';
  }

  switch (field) {
    case 'isMergedPickup':
      if (data._isDetail) {
        return null;
      }
      return <ExpandCellRenderer {...props} />;

    case 'shipperName':
      return (
        <div className={classes.shipperNameContainer}>
          <span className={classes.groupCount}>({data.groupCount})</span>
          {data.shipperName}
        </div>
      );

    case 'pickupNumberList':
      return (
        <PickupNumberRenderer
          {...props}
          data={{
            ...data,
            ...data.groupAggregatedData
          }}
          isGroupHeader={true}
          value={data.pickupNumber}
        />
      );

    case 'isGeoCoded':
      return <GeoCodeRenderer {...props} value={data.isGeoCoded} />;

    case 'pickupType':
      return getPickupTypeString(data.allPickupTypes, data.pickupType);

    case 'specialInstructions':
      return data.allSpecialInstructions || data.specialInstructions || '';

    case 'quoteNumber':
      return data.allQuoteNumbers || data.quoteNumber || '';

    case DRIVER_RECOMMENDATION_COL_ID:
      return <RecommendationRenderer {...props} />;

    default:
      return value || '';
  }
};

export default StyledGroupCellRenderer(GroupCellRenderer);
